// extracted by mini-css-extract-plugin
module.exports = {"files":"Dropzone_files__3L4Bv","file_input":"Dropzone_file_input__2qXsc","color":"Dropzone_color__3nMI3"};